/**
 * Redirecciones permanentes de la consolidación del blog (marketing v1.8).
 *
 * Cada slug fusionado apunta directamente al post que lo absorbe. Se sirven
 * desde next.config.mjs porque ningún endpoint del backend escribe
 * `redirects_from`; los posts fusionados solo se archivan cuando este
 * despliegue ya está en producción, así que ninguna URL llega a dar 404.
 *
 * Fichero derivado. Se genera con scripts/generarRedireccionesConsolidacion.mjs
 * desde .planning/marketing-v18/contenido-blog/operaciones.json (repositorio
 * raíz, generado el 2026-10-06T16:12:38.289Z); no editar a mano.
 */
export const REDIRECCIONES_CONSOLIDACION = [
  { from: "apps-ia-para-psicologos", to: "mejores-herramientas-ia-psicologos" },
  { from: "ia-para-psicologos-gratis-opciones", to: "mejores-herramientas-ia-psicologos" },
  { from: "plataforma-ia-para-psicologos", to: "mejores-herramientas-ia-psicologos" },
  { from: "ia-para-psicologos-guia-completa", to: "como-utilizar-ia-en-psicologia" },
  { from: "existe-ia-para-psicologos", to: "como-utilizar-ia-en-psicologia" },
  { from: "ia-para-psicologos-clinicos", to: "como-utilizar-ia-en-psicologia" },
  { from: "formacion-ia-para-psicologos", to: "como-utilizar-ia-en-psicologia" },
  { from: "implementar-ia-psicologia-therapyrecap", to: "como-utilizar-ia-en-psicologia" },
  { from: "como-superar-el-sindrome-del-domingo-al-redactar-notas-clinicas", to: "como-reducir-el-tiempo-administrativo-en-tu-consulta-privada-de-psicologia" },
  { from: "como-dejar-de-perder-10-horas-semanales-en-notas-clinicas-la-realidad-de-la-documentacion", to: "como-reducir-el-tiempo-administrativo-en-tu-consulta-privada-de-psicologia" },
  { from: "cmo-dejar-de-perder-10-horas-semanales-en-notas-clnicas-la-realidad-de-la-documentacin-en-2026", to: "como-reducir-el-tiempo-administrativo-en-tu-consulta-privada-de-psicologia" },
  { from: "software-de-gestion-clinica-o-marketplace-de-captacion-guia-para-elegir-en-tu-consulta-de", to: "software-de-gestion-clinica-o-marketplace-de-captacion-guia-comparativa-con-precios-reales" },
];

/** Posts que sobreviven a la consolidación: los únicos destinos válidos. */
export const POSTS_CONSERVADOS = [
  "mejores-herramientas-ia-psicologos",
  "como-utilizar-ia-en-psicologia",
  "chatgpt-como-psicologo-limites",
  "therapyrecap-vs-psicotools",
  "therapyrecap-vs-heidi-health",
  "therapyrecap-vs-upheal",
  "therapyrecap-vs-nabla",
  "notas-soap-psicologia-formato-ejemplo",
  "notas-pirp-psicologia-formato-ejemplo",
  "redactar-plan-tratamiento-psicologico-ia",
  "automatizar-notas-evolucion-psicologia-ia",
  "como-reducir-el-tiempo-administrativo-en-tu-consulta-privada-de-psicologia",
  "software-de-gestion-clinica-o-marketplace-de-captacion-guia-comparativa-con-precios-reales",
  "cumplimiento-normativo-y-gestion-en-la-consulta-privada-una-responsabilidad-continua",
  "investigacion-clinica-febrero-2026",
];
